import type { SaleInvoice } from "./invoice.interface";
import { InvoiceGenerator } from "./invoice-generator";

export class PurchaseInvoiceGenerator {
  private invoiceGenerator: InvoiceGenerator;
  constructor(invoice: SaleInvoice) {
    this.invoiceGenerator = new InvoiceGenerator(invoice, {
      type: "purchase",
    });
  }

  public print() {
    this.invoiceGenerator.print();
  }
}
